// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APP_VERSION: '211114',
  APP_TOKEN_KEY: '432A07458',
  //base_url: 'https://arisapi.davidmolinaojeda.com/v1',
  //url: 'https://arisapi.davidmolinaojeda.com'
  base_url: 'https://zona-api.aris.com.pe/v1',
  url: 'https://zona-api.aris.com.pe'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
